module.exports = __webpack_public_path__ + "img/ES.1ce544c8.svg";